<template>
    <div class="personinfo">
        <mt-header :title="title" class="fixedtop">
            <mt-button icon="back" slot="left" @click.native='back'></mt-button>
        </mt-header>
        <div class="infobody">
            <div class="titlebox" style="padding:18px 20px;">
                <div class="line"></div>
                <h1>擅长技能<span style="color: #cdc9c9;margin-left: 4px;">可多选</span></h1>
            </div>
            <div class="container">
                <div class="dataGroup">
                    <p>选择技能<span style="color:red;font-weight:bold">*</span></p>
                    <p class="selectskill" @click="showskills">></p>
                </div>
                <div class="labels">
                    <span v-for="(item,index) in selectskills" :key="index">{{item}}</span>
                </div>
               <div style="height:57px;"></div>
            </div>
            <div class="next">
                <van-button type="info" @click="back">上一步</van-button>
                <van-button type="info" @click="save">下一步</van-button>
            </div>
        </div>
        <van-popup v-model="pickskills" position="bottom" >
            <div class="selectskillsbox">
                <mt-header title="选择技能标签">
                    <van-icon name="cross" @click.native="onClose" slot="right"/>
                </mt-header>
                <div class="skilldiv">
                    <div v-for="(item,index) in skills" :key="index">
                        <p>{{item.value}}</p>
                        <ul class="label_val">
                            <li v-for="(itemchildren,index) in item.children"  ref="skillsName" @click="toggle(itemchildren)" :key="index" :class="{select: itemchildren.active === '1'}">
                                <span>{{itemchildren.name}}</span>
                            </li>
                        </ul>
                    </div>
                    <div style="height:100px;"></div>
                </div>
                <div class="btn">
                    <van-button type="info" @click="saveselectskills">保存</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Toast, MessageBox, Indicator } from 'mint-ui'
export default {
    data(){
        return{
            title:'个人信息',
            pickskills:false,
            skills:[],
            selectskills:[],
            skillArr:[]
        }
    },
    created(){
        this.$emit('footer', false);
        this.datainfo();
    },
    methods:{
        showskills(){
            this.pickskills=true
        },
        onClose(){
            this.selectskills=[]
            this.pickskills=false
            this.datainfo()
        },  
        toggle(event){
            if(!event.active){
                if(this.selectskills.length>19){
                    Toast({
                        message: '最多选择20项',
                        position: 'middle',
                        className: 'indexClass',
                        duration: 1000
                    })
                    return false
                }
                event.active='1'
                this.selectskills.push(event.name)
            }else if(event.active==='1'){
                event.active='0'
                if(this.selectskills.indexOf(event.name)>-1){
                    this.selectskills.splice(this.selectskills.indexOf(event.name),1)
                }
            }else{
                if(this.selectskills.length>19){
                    Toast({
                        message: '最多选择20项',
                        position: 'middle',
                        className: 'indexClass',
                        duration: 1000
                    })
                    return false
                }
                event.active='1'
                this.selectskills.push(event.name)
            }
        },
        datainfo(){
            let _this = this
            function httpUrl () {
                return _this.axios.get('url/user/imgHttpUrl.json')
            }
            function userInfomationById () {
                return _this.axios.get('url/userName/getUserInformation?accountId='+sessionStorage.getItem('loginId'))
            }
            function loadSelect () {
                return _this.axios.get('url/account/userInfo/vueGetInfomationData')
            }
            Indicator.open({
                text: '加载中...',
                spinnerType: 'fading-circle'
            })
            _this.axios.all([httpUrl(),userInfomationById(),loadSelect()])
                .then(_this.axios.spread(function (imgurl, userInfo, load) {
                    Indicator.close()
                    _this.skills=load.data.skills
                    // 技能反显
                    if (userInfo.data.skills !== null && userInfo.data.skills !== '') {
                        _this.skillArr = userInfo.data.skills.split('@')
                        _this.selectskills=userInfo.data.skills.split('@')
                        if (_this.skillArr != null && _this.skillArr.length > 0) {
                            for (var i = 0; i < _this.skills.length; i++) {
                                for (var j = 0; j < _this.skills[i].children.length; j++) {
                                    for (var k = 0; k < _this.skillArr.length; k++) {
                                        if (_this.skills[i].children[j].name === _this.skillArr[k]) {
                                            _this.skills[i].children[j].active = '1'
                                        }
                                    }
                                }
                            }
                        }
                    }
                }))
        },
        back(){
            this.$router.push('/baseinfo')
        },
        save(){
            let _this = this
            var skillsName=''
            if (_this.selectskills.length > 0) {
                for (var i = 0; i < _this.selectskills.length; i++) {
                    if ((i + 1) < _this.selectskills.length) {
                        skillsName += _this.selectskills[i] + '@'
                    } else {
                        skillsName += _this.selectskills[i]
                    }
                }
            }
            if(skillsName===''||skillsName===undefined){
                 Toast({
                    message: '请选择擅长技能',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
                return false
            }
            _this.axios({
                method: 'POST',
                url: '/url/account/userInfo/vueUpdateUserInformation',
                timeout: 100000,
                data: {
                    skills:skillsName,
                    updateFlag:2,
                    accountId:sessionStorage.getItem('loginId')
                }
            }).then(function (res) {
                if(res.data.success){
                    _this.$router.push({path:'/personinfo'})
                }else{
                    Toast({
                        message: res.data.msg,
                        position: 'middle',
                        className: 'indexClass',
                        duration: 1000
                    })
                }
            }).catch(function (res) {
                Toast({
                    message: '编辑资料失败',
                    position: 'middle',
                    className: 'indexClass',
                    duration: 1000
                })
            })
        },
        saveselectskills(){
            this.pickskills=false
        }
    }
}
</script>

<style scoped>
    .fixedtop{
        position:fixed;
        top:0;
        width:100%;
        z-index:1000;
    }
    .infobody .titlebox{
        margin-top:40px;
    }
    .infobody .titlebox .line{
        width: 8px;
        height: 12px;
        background: #6ba5e0;
        display: inline-block;
    }
    .infobody h1{
        display:inline-block;
        font-weight: bold;
        font-size:15px;
    }
    .infobody .dataGroup{
        border-bottom: 1px solid #ddd;
        border-top: 1px solid #ddd;
        padding:13px;
    }
    .infobody .dataGroup p{
        font-size:14px;
        display: inline-block;
    }
    .infobody .dataGroup .selectskill{
        display: inline-block;
        float:right;
        font-size:16px;
        text-align: right;
    }
    .next{
        position:fixed;
        text-align:center;
        bottom:0;
        background:#fff;
        width:100%;
        padding:10px 0;
    }
    .next .van-button{
        width:40%;
        height:37px;
        border-radius: 5px;
        color:#fff;
    }
    .selectskillsbox{
        display:flex;
        flex-direction: column;
        height:100vh;
    }
    .van-popup .mint-header{
        text-align:center;
        width:100%;
        background:#fff;
        color:#000;
        height:40px;
        line-height: 40px;
        position:fixed;
        top:0;
        z-index:1000;
    }
    .skilldiv{
        padding:0 10px;
        height: 100%;
        overflow-y: auto;
        margin-top:40px;
        margin-bottom:57px;
    }
    .skilldiv p{

    }
    .label_val{
        padding:10px;
        overflow:hidden;
        display: flex;
        flex-wrap: wrap;
    }
    .label_val li{
        float:left;
        background:#d7d7d7;
        border:1px solid #d7d7d7;
        color:#685f56;
        border-radius:15px;
        -webkit-border-radius:15px;
        -moz-border-radius:15px;
        padding:2px 10px;
        margin:5px;
    }
    .select{
        background:#ccedfc!important;
        border:1px solid #ccedfc!important;
    }
    .btn{
        width:100%;
        background:#fff;
        text-align: center;
        height: 57px;
        line-height: 57px;
        position:fixed;
        bottom:0;
    }
    .btn .van-button{
        width:40%;
        height:37px;
        border-radius: 5px;
        margin:10px 0;
    }
    .labels{
        padding:0 10px;
        margin-top:15px;
        display: flex;
        flex-wrap: wrap;
    }
    .labels span{
        float: left;
        background: #ccedfc;
        border: 1px solid #ccedfc;
        color: #685f56;
        border-radius: 15px;
        -webkit-border-radius: 15px;
        -moz-border-radius: 15px;
        padding: 2px 10px;
        margin: 5px;
    }
</style>


// WEBPACK FOOTER //
// skills.vue?17831d3d